import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import get from 'lodash/get';
import Layout from '~/src/layout/_layout';
import * as tagsActions from '~/src/store/actions/tags';
import * as newsActions from '~/src/store/actions/news';
import * as base from '../src/helpers/basePageFunc';
import News from '~/src/components/News';

class NewsPage extends Component {
    static propTypes = {
        currentCity: PropTypes.object,
        hostname: PropTypes.string,
    }

    static defaultProps = {
        currentCity: {},
        hostname: '',
    }

    static async getInitialProps(options) {
        const { hostname } = await base.initialProps(options);

        const { store, query } = options;
        const { tags, month, year, page } = query;

        const { city } = store.getState();
        const domainCity = get(city, 'currentCity.domain');

        await Promise.all([
            store.dispatch(tagsActions.getList()),
            store.dispatch(newsActions.getList({ domainCity, page, tags, month, year })),
        ]);

        return { hostname };
    }

    render() {
        const { currentCity, hostname } = this.props;
        const { cityIn, domain } = currentCity;
        const clientHostname = process.browser ? document.location.hostname : hostname;

        return (
            <Layout
                title={`Все новости от провайдера домашнего интернета, телевидения и телефона Дом.ru в ${cityIn}`}
                description={'Следите за новостями Дом.ru: быстрый Интернет, Цифровое Телевидение HD качества, IP-телефония.'}
                hostname={clientHostname}
                withMenu={true}
                withHeader={true}
                withChat={true}
                withFooter={true}
                relCanonical={`https://${domain}.dom.ru/news`}
            >
                <News />
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    currentCity: get(state, 'city.currentCity'),
});


export default withRouter(connect(mapStateToProps)(NewsPage));
